import React, { useEffect, useState } from 'react';
import { useA11y } from '@context/Utils/A11y';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { tA11y, replaceDynamicCmsContent } from '@utils/a11y/a11yHelpers';
import { appButtonType, appCardStyle, appChipSize, appChipStyle, appIconsPath, appStorage, getKeyByValue } from '@utils/globalConstant';
import { ButtonPrimary } from '@core/ButtonPrimary';
import { Ta11yText, ScrollToTop, Chip } from '@core/index';
import { useActivation } from '@context/MobileOne';
import { useConfig } from '@config/ContextManager';
import { Link } from '@core/Link';
import './Step10.scss';
import Icons from '@core/Utils/Icons/Icons';

export const LegitimationProcess = () => {
  // context
  const {
    setStep10SubStep,
    legitimationUrl,
    legitimationCode,
    personalDataForm,
    setPostIdentUrl,
    setLegitimationUrl,
    setLegitimationCode
  } = useActivation();
  const {
    config: { storage }
  } = useConfig();
  const { tA11yTranslate } = useA11y();

  // state
  const [copied, setCopied] = useState(false);
  const [legitimationName, setLegitimationName] = useState('');

  // const
  const headerContent = tA11y('ek_reg_legitimation_hdl1');
  const text1Content = tA11y('ek_reg_legitimation_txt1');
  const infoBoxHeaderContent = tA11y('ek_reg_legitimation_hdl2');
  const infoBoxListContent = tA11y('ek_reg_legitimation_txt2');
  const buttonContent = tA11y('ek_reg_legitimation_btn1');
  const text2Content = tA11y('ek_reg_postidnt_txt2');
  const labelButtonCopyContent = tA11y('ek_reg_postidnt_lbl');

  const handleLegitimationButtonClick = () => {
    setStep10SubStep(1);
    window.open(legitimationUrl, '_blank');
  };

  const handleCopyButtonClick = () => {
    navigator.clipboard.writeText(legitimationCode);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 5000);
  };

  const handleLinkClick = () => {
    setStep10SubStep(1);
  };

  const loadLegitimationCode = async () => {
    // const storedLegitimationCode = await sessionStorage.getItem("legitimationCode");
    try {
      const postidentUrlFromActivateSim = await storage.encryptedGetItem(appStorage.POSTIDENT);
      const legitimationUrlFromActivateSim = await storage.encryptedGetItem(appStorage.LEGITIMATION_URL);
      const legitimationCodeInUse = await storage.encryptedGetItem(appStorage.LEGITIMATION_CODE);
      const storeLegitimationName = await storage.encryptedGetItem(appStorage.LEGITIMATION_NAME);
      if (postidentUrlFromActivateSim ) {
        setPostIdentUrl(postidentUrlFromActivateSim);
      }
      if (legitimationUrlFromActivateSim) {
        setLegitimationUrl(legitimationUrlFromActivateSim);
      }
      if (legitimationCodeInUse) {
        setLegitimationCode(legitimationCodeInUse);
      }
      if (storeLegitimationName) {
        setLegitimationName(storeLegitimationName);
      }
    } catch (error) {
      console.error('Error loading legitimation code:', error);
    }
  };

  useEffect(() => {loadLegitimationCode();}, []);

  return (
    <>
      <ScrollToTop>
        <div className="postident-container min-dvh-100">
          <AppPageContentWrapper>
            <div className="postident-content-wrapper d-flex flex-column align-items-center">
              <Icons name='CELEBRATE' colorType='dark' />
              <Ta11yText
                textContent={headerContent}
                className="ek-h1 text-primary pt-40 text-center"
                tag="h1"
              />
              <Ta11yText
                textContent={replaceDynamicCmsContent(
                  text1Content,
                  '{LEGITIMATION_NAME}',
                  legitimationName
                )}
                className="ek-copy-16-regular text-primary pt-40 text-center"
                tag="p"
              />
              <div
                className={`${appCardStyle.DEFAULT_GRADIENT} rounded-5 p-16 w-100 mt-40 mb-0 legitimation-info-box`}>
                <Ta11yText
                  textContent={infoBoxHeaderContent}
                  className="ek-h3 text-primary"
                  tag="p"
                />
                <Ta11yText
                  textContent={infoBoxListContent}
                  className="pt-16 text-primary"
                  tag="div"
                />
              </div>
              <div className="button-container w-100 pt-40 d-flex justify-content-center">
                <div className="col-lg-5 col-md-7 col-10 px-0 mx-auto">
                  <ButtonPrimary
                    buttonContent={replaceDynamicCmsContent(
                      buttonContent,
                      '{LEGITIMATION_NAME}',
                      legitimationName
                    )}
                    onClick={handleLegitimationButtonClick}
                  />
                </div>
              </div>
              <div className="copy-text-container pt-40 w-100">
                <Ta11yText
                  textContent={replaceDynamicCmsContent(
                    text2Content,
                    '{LEGITIMATION_NAME}',
                    legitimationName
                  )}
                  className="ek-copy-16-regular text-primary"
                  tag="p"
                />
              </div>
              <div className="copy-button-container w-100 pt-40">
                <Ta11yText
                  textContent={labelButtonCopyContent}
                  className="ek-h3 text-primary pb-12"
                  tag="p"
                />
                <div className='position-relative'>
                  {copied ? <div className='info-alert' role='alert'>
                    <div className={`d-inline-block ${appChipStyle.SECONDARY} ${appChipSize.SMALL}`}>
                      <div className="d-flex align-items-center">
                        <Icons name={getKeyByValue(appIconsPath,appIconsPath.CHECK)}  className={`filter-ek-primary pe-8`} height={16} alt="" colorType='dark' />
                        <Ta11yText
                          textContent={tA11y('ek_global_copy_code_txt1')}
                          tag="p"
                          className="pe-4 mb-0 ek-labeltext-12-medium"
                        />
                      </div>
                    </div>
                  </div> : null}
                  <ButtonPrimary
                    buttonType={appButtonType.WHITE}
                    label={legitimationCode}
                    iconRight={copied ? appIconsPath.CHECK_GREEN_OUTLINED : appIconsPath.COPY}
                    onClick={handleCopyButtonClick}
                    aria-label={tA11yTranslate("ek_global_icn_copy_aria").ariaLabel}
                  />
                </div>
              </div>
              <Link label="ek_reg_legitimation_lnk1" linkStyle="pt-40" onClick={handleLinkClick} />
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
};

export default LegitimationProcess;
